import type { CityConfig } from "../city-template/types";

export const loneTreeConfig: CityConfig = {
  city: "Lone Tree",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "lone-tree",
  route: "/cities/lone-tree",
  title: "Emergency Passport Lone Tree, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Lone Tree, Colorado — as fast as 24 hours. Same-day courier processing for Lone Tree, Highlands Ranch, Centennial, Parker, Castle Pines, and all Douglas County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Lone Tree, CO",
  heroSubtitle: "International business trip from the DTC and your passport just expired? Family ski vacation in the Alps departing this weekend? We help Lone Tree residents — from Park Meadows shoppers to Sky Ridge Medical professionals to Douglas County executives — get their passports quickly. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Lone%20Tree%20Colorado%20upscale%20suburban%20landscape%20with%20the%20Park%20Meadows%20Mall%20distinctive%20lodge%20style%20architecture%20visible%2C%20the%20Denver%20Tech%20Center%20skyline%20in%20the%20distance%20with%20modern%20office%20buildings%2C%20the%20Bluffs%20Regional%20Park%20with%20scenic%20overlooks%20and%20walking%20trails%20along%20the%20ridge%2C%20the%20Lincoln%20Avenue%20corridor%20with%20landscaped%20medians%20and%20retail%20developments%2C%20warm%20golden%20Colorado%20sunset%20light%20illuminating%20the%20Front%20Range%20foothills%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20cinematic%20view%20with%20rich%20warm%20tones&width=1800&height=700&seq=lonetree-hero-001&orientation=landscape",
  heroImageAlt: "Lone Tree Colorado with Park Meadows retail district and Denver Tech Center skyline",
  geoPosition: "39.5336;-104.8733",
  geoPlacename: "Lone Tree, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 20 miles north via I-25 and C-470 — about 25–30 minutes",
  },
  nearbyCitiesZips: [
    { name: "Lone Tree", zips: "80124" },
    { name: "Highlands Ranch", zips: "80126, 80129, 80130" },
    { name: "Centennial", zips: "80111, 80112, 80122" },
    { name: "Parker", zips: "80134, 80138" },
    { name: "Castle Pines", zips: "80108" },
    { name: "Greenwood Village", zips: "80111, 80121" },
    { name: "Englewood", zips: "80112, 80110" },
    { name: "Castle Rock", zips: "80104, 80109" },
    { name: "Meridian", zips: "80112" },
    { name: "Dove Valley", zips: "80112" },
    { name: "Acres Green", zips: "80124" },
    { name: "Heritage Hills", zips: "80124" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Lone Tree international departures via DEN" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — skip the drive to Aurora" },
    { icon: "ri-flight-takeoff-line", title: "DTC & I-25 Corridor", desc: "Prime Denver Tech Center location with direct I-25 access to DIA" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from UPS or FedEx in Lone Tree, Highlands Ranch, or Centennial" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/cities/denver" },
    { name: "Emergency passport help in Centennial, CO", route: "/cities/centennial" },
    { name: "Fast passport renewal in Lone Tree area", route: "/cities/lone-tree" },
    { name: "Urgent passport services for Highlands Ranch and Parker", route: "/cities/highlands-ranch" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in Castle Pines and Castle Rock", route: "/cities/castle-rock" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Lone Tree remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Lone Tree's prime location in the Denver Tech Center corridor — just 20 miles from the Colorado Passport Agency and adjacent to the I-25/C-470 junction — makes our courier service the most efficient choice for south metro professionals and families.",
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeDistance: "Serving all of Lone Tree, the Denver Tech Center corridor, and southern Douglas County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Lone Tree and the surrounding south metro area. From the Park Meadows retail district to the Lincoln Avenue medical corridor near Sky Ridge, from the residential communities near Bluffs Regional Park to the Meridian business park — we serve every corner of Lone Tree and the surrounding communities.",
  nearbyCitiesIntro: "We serve Lone Tree and all nearby communities including Highlands Ranch, Centennial, Parker, Castle Pines, Greenwood Village, Englewood, Castle Rock, and the entire Denver Tech Center corridor.",
  howItWorksIntro: "Most Lone Tree travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — you never need to navigate I-25 and C-470 through the DTC corridor to Aurora.",
  mistakesIntro: "Lone Tree is a premier south metro hub — home to the Park Meadows retail district, Sky Ridge Medical Center, and the Denver Tech Center business corridor. Here are the most common passport mistakes we see from Lone Tree-area travelers.",
  testimonialsIntro: "Lone Tree travelers — from DTC business executives to Sky Ridge medical professionals to Park Meadows-area families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Lone Tree, CO? Here are the most common ones we hear from Douglas County travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Aurora (25–30 minutes each way)", "I-25/C-470 interchange traffic is unpredictable"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Aurora drive required — ship from Lone Tree", "Perfect for DTC business travelers and family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Lone Tree travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest service available without fighting DTC traffic on I-25.",
      bullets: ["24–48 hour turnaround available", "DIA (DEN) departure support via I-25/C-470", "Business travel and family vacation expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Lone Tree adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Lone Tree address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Lone Tree residents and Douglas County families — including DTC professionals and their families.",
      bullets: ["Acceptance facility scheduling in Lone Tree or Centennial", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Lone Tree residents who lost their passport before international business travel or family vacation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Lone Tree and south metro families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Lone Tree and Douglas County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Lone Tree CO", description: "Urgent passport processing for Lone Tree Colorado travelers with immediate departure needs from DEN." },
    { name: "Expedited Passport Renewal Lone Tree CO", description: "Fast passport renewal for Lone Tree Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Lone Tree CO", description: "New passport application services for Lone Tree Colorado residents applying for their first passport." },
    { name: "Child Passport Lone Tree CO", description: "Minor passport services for Lone Tree Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "James H.",
      location: "Lone Tree, CO — Lincoln Avenue",
      rating: 5,
      text: "Business trip to Singapore with 5 days notice — needed my passport renewed fast. Fast Passport Center handled it in 3 days. Being in the DTC, I shipped from the UPS Store on Lincoln and everything was flawless.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Stephanie W.",
      location: "Lone Tree, CO — Heritage Hills",
      rating: 5,
      text: "Family trip to London and Paris planned for months. Discovered my daughter's passport expired just 10 days before. Fast Passport Center got her renewal done in 4 days. Shipped from the UPS Store at Park Meadows — so convenient.",
      service: "Emergency Child Passport Renewal",
    },
    {
      name: "David L.",
      location: "Lone Tree, CO — Near Sky Ridge",
      rating: 5,
      text: "Medical conference in Barcelona and my passport had water damage. Fast Passport Center replaced it in 4 days. As a physician at Sky Ridge, I appreciate efficiency — and they delivered.",
      service: "Emergency Passport Replacement",
    },
    {
      name: "Rebecca M.",
      location: "Centennial, CO — Near Lone Tree border",
      rating: 5,
      text: "First-time passports for our whole family heading to Costa Rica. Fast Passport Center guided us through the DS-11 process and got all four passports in 6 days. Absolutely fantastic service for the south metro community.",
      service: "Family Passport Bundle",
    },
  ],
  facilities: [
    {
      id: "lt-1",
      name: "Lone Tree Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10249 Park Meadows Dr",
      city: "Lone Tree",
      state: "CO",
      zip: "80124",
      phone: "(303) 790-0825",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Central Lone Tree, near Park Meadows Mall",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Lone Tree acceptance facility. Located near Park Meadows retail district. Convenient for Lone Tree, Heritage Hills, and Acres Green residents. Appointments recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "lt-2",
      name: "Centennial Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7500 S University Blvd",
      city: "Centennial",
      state: "CO",
      zip: "80122",
      phone: "(303) 798-1162",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 3 miles north of Lone Tree, in Centennial",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northern acceptance facility for Lone Tree-Centennial corridor. Good alternative when Lone Tree appointments are full. Near Arapahoe Road.",
      icon: "ri-mail-line",
    },
    {
      id: "lt-3",
      name: "Highlands Ranch Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9609 S University Blvd",
      city: "Highlands Ranch",
      state: "CO",
      zip: "80126",
      phone: "(303) 791-3080",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 4 miles west of Lone Tree, in Highlands Ranch",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Western acceptance facility for Lone Tree-Highlands Ranch corridor residents. Convenient C-470 access. Good parking availability.",
      icon: "ri-mail-line",
    },
    {
      id: "lt-4",
      name: "Douglas County Clerk & Recorder — Lone Tree",
      type: "County Clerk Passport Acceptance",
      address: "9350 Heritage Hills Cir",
      city: "Lone Tree",
      state: "CO",
      zip: "80124",
      phone: "(303) 660-7469",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Lone Tree, near the Heritage Hills area",
      website: "https://www.douglas.co.us/",
      websiteLabel: "Douglas County Clerk",
      notes: "County government passport acceptance in Lone Tree. Extended hours including 8AM opening and 5PM closing. Most convenient option for Lone Tree residents. Serves all Douglas County.",
      icon: "ri-government-line",
    },
    {
      id: "lt-5",
      name: "Greenwood Village Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6000 S Quebec St",
      city: "Greenwood Village",
      state: "CO",
      zip: "80111",
      phone: "(303) 771-2570",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 5 miles north of Lone Tree, in Greenwood Village",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northern acceptance facility in the DTC corridor. Serves the Lone Tree-Greenwood Village business corridor. Good for DTC professionals.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 20-mile drive to Aurora via I-25/C-470", fpc: "No — ship from Lone Tree" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "DTC Rush Hour Traffic", agency: "I-25 corridor through DTC is heavily congested", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until Peak Business Travel Season",
      description: "Lone Tree's DTC business travelers often wait until the last minute before international conferences. Routine processing takes 8–11 weeks. Start expedited service at least 4 weeks before your departure — especially for spring and fall conference seasons.",
    },
    {
      icon: "ri-image-line",
      title: "Relying on Mall Photo Booths",
      description: "Photo booths at Park Meadows Mall may not produce State Department-compliant passport photos. Head positioning, lighting, and background requirements are strict. Use trained staff at UPS Store, FedEx Office, or Walgreens instead.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Using the Douglas County Clerk in Lone Tree",
      description: "The Douglas County Clerk office in Lone Tree (Heritage Hills Cir) is the most convenient acceptance facility — but many residents don't know it exists. It opens at 8AM, making early morning appointments possible before work.",
    },
    {
      icon: "ri-car-line",
      title: "Underestimating DTC Corridor Traffic",
      description: "Driving from Lone Tree to the Aurora passport agency requires navigating the I-25/C-470/DTC corridor — one of Colorado's busiest stretches. Rush hour can easily turn a 25-minute drive into 45+ minutes.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Visa Requirements Alongside Passport",
      description: "DTC business travelers heading to multiple countries on a single trip need to check both passport validity and visa requirements for each destination. A valid passport doesn't guarantee entry if a visa is also required.",
    },
    {
      icon: "ri-briefcase-line",
      title: "Assuming Company Travel Department Handles Passports",
      description: "Many DTC companies have travel departments, but they typically don't handle passport processing. Lone Tree business travelers should verify passport status independently — don't assume your employer has it covered.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Lone Tree or Douglas County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at UPS or FedEx in Lone Tree, Park Meadows, or Centennial." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Douglas County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no DTC I-25 traffic battle required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Lone Tree address — trackable every step." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Lone Tree, CO?", a: "Fast Passport Center offers emergency passport processing in Lone Tree, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to navigate I-25 through the DTC corridor to the Aurora passport agency." },
    { q: "Does Lone Tree have its own passport acceptance facility?", a: "Yes — Lone Tree has both the Lone Tree Post Office (near Park Meadows) and the Douglas County Clerk office (Heritage Hills Cir). The County Clerk office is the most convenient option with extended hours from 8AM to 5PM." },
    { q: "What if I work in the DTC but live elsewhere?", a: "Absolutely. Fast Passport Center serves all DTC corridor professionals regardless of where you live. If you work in Lone Tree, Centennial, Greenwood Village, or the Meridian business park, you can ship your documents from your workplace area and receive your passport at your home address." },
    { q: "Can you help with passports for DTC business travelers?", a: "Yes — this is one of our core services for the Lone Tree/DTC community. We understand the unique needs of business travelers with tight schedules and last-minute international conference trips. Expedited processing with daily status updates keeps you informed at every step." },
    { q: "How much does an expedited passport cost in Lone Tree, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Lone Tree?", a: "UPS Store at Park Meadows, FedEx Office on County Line Road, Walgreens on Quebec Street, and CVS near Sky Ridge Medical Center all offer passport photo services. Photos must be 2×2 inches on a white background, taken within 6 months, with no glasses and a neutral expression." },
    { q: "Does Fast Passport Center serve all of the south metro Denver area?", a: "Yes. Fast Passport Center serves the full south metro corridor including Lone Tree, Highlands Ranch, Centennial, Greenwood Village, Parker, Castle Pines, Castle Rock, and all surrounding Douglas and Arapahoe County communities." },
    { q: "How close is Lone Tree to Denver International Airport?", a: "Lone Tree is approximately 35 miles from Denver International Airport via I-25 and E-470 — about 35–40 minutes in normal traffic. Our courier service ensures your passport is ready well before you need to make that drive." },
  ],
  photoLocations: [
    { name: "UPS Store — Park Meadows", address: "9227 E Lincoln Ave, Lone Tree, CO 80124", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM" },
    { name: "Walgreens — Lone Tree", address: "9231 E Lincoln Ave, Lone Tree, CO 80124", hours: "Mon–Sun: 8AM–9PM" },
    { name: "FedEx Office — Lone Tree", address: "8481 S Yosemite St, Lone Tree, CO 80124", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM" },
    { name: "CVS — Lone Tree", address: "10101 RidgeGate Pkwy, Lone Tree, CO 80124", hours: "Mon–Sun: 8AM–9PM" },
  ],
  dmvLocations: [
    { name: "DMV — Lone Tree (Douglas County)", address: "9350 Heritage Hills Cir, Lone Tree, CO 80124", hours: "Mon–Fri: 8AM–5PM", note: "Douglas County DMV in Lone Tree. REAL ID and driver's license renewals. Most convenient option for Lone Tree residents. Located at the Heritage Hills government center.", featured: true },
    { name: "DMV — Centennial (Arapahoe County)", address: "6954 S Lima St, Centennial, CO 80112", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV in Centennial near the Lone Tree border. REAL ID processing available. Good for residents near the northern Lone Tree boundary.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "35 miles north via I-25 and E-470 — approximately 35–40 minutes",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Accessible from Lone Tree via I-25 north and E-470 — convenient for DTC business travelers.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "APA",
      name: "Centennial Airport",
      distance: "5 miles northeast via I-25 — approximately 10 minutes",
      address: "7800 S Peoria St, Englewood, CO 80112",
      note: "One of the busiest general aviation airports in the United States. Private and corporate jet services only — no scheduled commercial flights. Extremely convenient for Lone Tree and DTC private aviation travelers.",
      flightUrl: "https://www.centennialairport.com/",
      flightLabel: "APA Flight Info",
      featured: false,
    },
  ],
};